<ul class="steps " >
    <li class="step step-success">
      <div class="steps-content">
        <span class="step-circle">1</span>
        <span class="step-text">Vendor’s  Form</span>
        <div class="step-seperators"></div>
      </div>
    </li>
    <li class="step step-active">
      <div class="steps-content">
        <span class="step-circle">2</span>
        <span class="step-text">Initiator</span>
        <div class="step-seperators"></div>
      </div>
    </li>
    <li class="step">
      <div class="steps-content">
        <span class="step-circle">3</span>
        <span class="step-text">Initiator’s HOD</span>
        <div class="step-seperators"></div>
      </div>
    </li>
    <li class="step">
      <div class="steps-content">
        <span class="step-circle">4</span>
        <span class="step-text">QA</span>
        <div class="step-seperators"></div>
      </div>
    </li>
    <li class="step ">
      <div class="steps-content">
        <span class="step-circle">5</span>
        <span class="step-text">Finance</span>
        <div class="step-seperators"></div>
      </div>
    </li>
    <li class="step ">
      <div class="steps-content">
        <span class="step-circle">6</span>
        <span class="step-text">Legal Secretary</span>
        <div class="step-seperators"></div>
      </div>
    </li>
    <li class="step">
      <div class="steps-content">
        <span class="step-circle">7</span>
        <span class="step-text">Category Manager</span>
        <div class="step-seperators w-100"></div>
      </div>
    </li>
    <li class="step">
      <div class="steps-content">
        <span class="step-circle">8</span>
        <span class="step-text">Vendor Master<br />Manager</span>
      
      </div>
    </li>
  </ul> 